var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgIcnConversionHelp3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 72,
    viewBox: "0 0 100 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4757_29778)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.4658 36.0222L31.7317 33.7686V8.70389L29.4835 9.70648L29.4658 36.0222Z",
    fill: "#B0B0B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4833 9.70647L31.7316 8.70389L9.68962 8.53531L8.00562 9.71535L29.3687 9.80407",
    fill: "#F0F0F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.191 11.614H10.8535V14.3911H27.191V11.614Z",
    fill: "#FF4D48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4745 36.0311H7.98804V9.70647H29.4745V36.0311ZM8.19081 35.827H29.2541V9.93716H8.19081V35.827Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0952 36.0222L62.3611 33.7686V8.70389L60.104 9.70648L60.0952 36.0222Z",
    fill: "#B0B0B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1041 9.70647L62.3612 8.70389L40.3193 8.53531L38.6353 9.71535L60.0071 9.80407",
    fill: "#F0F0F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8204 11.614H41.4829V14.3911H57.8204V11.614Z",
    fill: "#FF4D48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1128 36.0311H38.6174V9.70647H60.1128V36.0311ZM38.829 35.827H59.91V9.93716H38.8202L38.829 35.827Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7249 36.0222L92.9908 33.7686V8.70389L90.7425 9.70648L90.7249 36.0222Z",
    fill: "#B0B0B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7423 9.70647L92.9906 8.70389L70.9487 8.53531L69.2646 9.71535L90.6365 9.80407",
    fill: "#F0F0F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4501 11.614H72.1125V14.3911H88.4501V11.614Z",
    fill: "#FF4D48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7336 36.0311H69.2471V9.70647H90.7336V36.0311ZM69.4499 35.827H90.5308V9.93716H69.4499V35.827Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4658 66.5967L31.7317 64.3519V39.2784L29.4835 40.2898L29.4658 66.5967Z",
    fill: "#B0B0B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4833 40.2898L31.7316 39.2784L9.68962 39.1098L8.00562 40.2898L29.3687 40.3874",
    fill: "#F0F0F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.191 42.1885H10.8535V44.9656H27.191V42.1885Z",
    fill: "#FF4D48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4745 66.6055H7.98804V40.281H29.4745V66.6055ZM8.19081 66.4015H29.2541V40.485H8.19081V66.4015Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0952 66.5967L62.3611 64.3519V39.2784L60.104 40.2898L60.0952 66.5967Z",
    fill: "#B0B0B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1041 40.2898L62.3612 39.2784L40.3193 39.1098L38.6353 40.2898L60.0071 40.3874",
    fill: "#F0F0F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8204 42.1885H41.4829V44.9656H57.8204V42.1885Z",
    fill: "#FF4D48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1128 66.6055H38.6174V40.281H60.1128V66.6055ZM38.829 66.4015H59.91V40.485H38.8202L38.829 66.4015Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7249 66.5967L92.9908 64.3519V39.2784L90.7425 40.2898L90.7249 66.5967Z",
    fill: "#B0B0B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7423 40.2898L92.9906 39.2784L70.9487 39.1098L69.2646 40.2898L90.6365 40.3874",
    fill: "#F0F0F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4501 42.1885H72.1125V44.9656H88.4501V42.1885Z",
    fill: "#FF4D48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7336 66.6055H69.2471V40.281H90.7336V66.6055ZM69.4499 66.4015H90.5308V40.485H69.4499V66.4015Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9913 3.42477L94.5601 0H15.2002L0.0441895 3.42477H99.9913Z",
    fill: "#F0F0F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.009 72.0444H0V3.40704H100.009V72.0444ZM0.440839 71.6007H99.568V3.85067H0.440839V71.6007Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4757_29778"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnConversionHelp3);
export default __webpack_public_path__ + "static/media/icn-conversion-help-3.0c099cdcf5c6482f79fb8123b5879128.svg";
export { ForwardRef as ReactComponent };